import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from 'src/app/shared/widget/notification/toast-service';
import { CommandsService } from 'src/app/core/services/command.service';
import {
  AccessoryModels,
  CanalEnvio,
  CommandinfoType,
  DeviceModels,
  Systems,
} from 'src/app/core/models/commands.model';
import { DomSanitizer } from '@angular/platform-browser';
import { List } from 'angular-feather/icons';
import { AuthService } from 'src/app/core/services/auth.service';
import { DeviceModel } from 'src/app/core/models/profiles.model';

@Component({
  selector: 'app-command-info',
  templateUrl: './command-info.component.html',
  styleUrls: ['./command-info.component.scss'],
})
export class CommandInfoComponent implements OnInit {
  constructor(
    public commandsService: CommandsService,
    private modalService: NgbModal,
    public formBuilder: UntypedFormBuilder,
    public toastService: ToastService,
    private sanitizer: DomSanitizer,
    private authService: AuthService
  ) {}

  viewMode: number = 1;
  viewModeQtd: number = 2;
  commandName: string[] = [];
  commandInfo: CommandinfoType[] = [];
  commandInfoFilter: CommandinfoType[] = [];
  commandInfoSelect: CommandinfoType[] = [];
  commandFilterName: string = '';
  commandFilterDeviceModel: string[] = [];
  commandFilterNameSelect: string[] = [];
  commandFilterChannelSendSelect: number[] = [];
  commandFilterSystemsSelect: string[] = [];
  ngIfCopyModel: boolean = false;
  isAccessory : boolean = false;

  deviceModels: DeviceModels[] = [];
  accessoryModels: DeviceModels [] = [];
  systems: any = Object.values(Systems).slice(
    0,
    Object.keys(Systems).length / 2
  );

  canalEnvioEnum: any = Object.values(CanalEnvio).slice(
    0,
    Object.keys(CanalEnvio).length / 2
  );

  circularProgressiveWait: Boolean = false;

  ngOnInit() {
    this.circularProgressiveWait = true;
    this.commandsService.getDeviceModels().subscribe((response) => {
      this.deviceModels = response;
    }); 
    this.commandsService.getAccessoryModels().subscribe((response) => {
      response.forEach((item : AccessoryModels) => {
        let newDevice : DeviceModels = { dispositivoModelo: item.acessorioModelo,  dispositivoModeloId: item.acessorioModeloId };
        this.accessoryModels.push(newDevice)      
      })      
    });

    this.commandsService.getCommandsInfoType().subscribe(
      (response) => {
        this.commandInfo = response;
        this.commandInfoFilter = response;
        this.commandInfo.forEach((item: CommandinfoType) => {
          if (item.sistemaNome != undefined) {
            item.sistemaAux = item.sistemaNome.split(',');
          }
        });
        this.commandInfoFilter.forEach((item: CommandinfoType) => {
          if (item.sistemaNome != undefined) {
            item.sistemaAux = item.sistemaNome.split(',');
          }
        });
        this.filter();
        this.circularProgressiveWait = false;
      },
      (error: HttpErrorResponse) => {
        this.circularProgressiveWait = false;

        this.toastService.show('Erro ao carregar itens - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
      }
    );
  }
  changeViewMode() {
    this.viewMode = this.viewMode + 1;
    if (this.viewMode > this.viewModeQtd) {
      this.viewMode = 1;
    }
  }
  prepareTooltip(item: CommandinfoType): string {
    let tooltip: string = `sistemas:${
      item.sistemaNome != null ? item.sistemaNome : ''
    }
    temParametro: ${item.valor}
    QtdParametro: ${item.quantidadeValor}
    Exemplo: ${item.exemplo}
    observações:${item.observacao}`;
    return tooltip;
  }
  sanitizerHTML(item: string) {
    return this.sanitizer.bypassSecurityTrustHtml(item) as string;
  }
  getChannelSend(item: CommandinfoType[], nome: string) {
    let canalEnvio: number = Number(
      item.filter((itemFilter: CommandinfoType) => {
        return itemFilter.nome == nome;
      })[0].canalEnvioId
    );
    return this.canalEnvioEnum[canalEnvio - 1];
  }

  getAvaliableDeviceModel(
    items: CommandinfoType[],
    commandName: string
  ): DeviceModels [] {
    let aux: any = []; 
    this.isAccessory == false ? aux = this.deviceModels : aux = this.accessoryModels
    let deviceModelItemsCommand: String[] = [];
    let itemsFilter = items.filter((itemFilter: CommandinfoType) => {
      return itemFilter.nome == commandName;
    });

    itemsFilter.forEach((itemFilterItem: CommandinfoType) => {
      if (itemFilterItem.dispositivoModelo != undefined) {
        deviceModelItemsCommand.push(itemFilterItem.dispositivoModelo);
      }
    });
    aux = aux.filter((itemAuxFilter: DeviceModels) => {
      return !deviceModelItemsCommand.includes(itemAuxFilter.dispositivoModelo);
    });   

    return aux;
  }

  getOtherItemsSameCommand(
    items: CommandinfoType[],
    commandName: string
  ): string[] {
    let aux: string[] = [];
    items.forEach((item: CommandinfoType) => {
      if (item.nome == commandName && item.dispositivoModelo != undefined) {
        if (!aux.includes(item.dispositivoModelo))
          aux.push(item.dispositivoModelo);
      }
    });
    return aux;
  }

  verifyCheckBox(item: any) {
    //console.log(item);
    return item;
  }

  changeModel(item: any) {
    let aux : DeviceModels = { dispositivoModelo : "", dispositivoModeloId : 0 };
    if(this.isAccessory) {
      aux = this.accessoryModels.filter(
        (itemDevice: DeviceModels) => {
          return itemDevice.dispositivoModelo == item;
        }
      )[0];
      this.commandInfoSelect[0].isAccessory = true;
    } else {
      aux = this.deviceModels.filter(
        (itemDevice: DeviceModels) => {
          return itemDevice.dispositivoModelo == item;
        }
      )[0];
      this.commandInfoSelect[0].isAccessory = false;
    }
    this.commandInfoSelect[0].dispositivoModeloId = Number(
      aux.dispositivoModeloId
    );
    this.commandInfoSelect[0].dispositivoModelo = aux.dispositivoModelo;
  }
  copyModel(event: any, comandoNome: string) {
    let dispositivoModelo = String(Object(event)['$ngOptionLabel']).trim();
    let modeloAux = this.commandInfoSelect[0].dispositivoModelo;
    let modeloIdAux = this.commandInfoSelect[0].dispositivoModeloId;
    let aux = new CommandinfoType(this.commandInfo[0]);
    aux.clone(
      this.commandInfo.filter((itemFilter: CommandinfoType) => {
        return (
          itemFilter.nome == comandoNome &&
          itemFilter.dispositivoModelo == dispositivoModelo
        );
      })[0]
    );

    aux.dispositivoModelo = modeloAux;
    aux.dispositivoModeloId = modeloIdAux;
    this.commandInfoSelect[0] = aux;
  }

  getCommandName(item: CommandinfoType[]) {
    let aux: any[] = [];
    item.forEach((item: CommandinfoType) => {
      if (!aux.includes(item.nome)) {
        aux.push(item.nome);
      }
    });
    return aux;
  }

  filter() {
    let aux = this.commandInfo;
    if (this.commandFilterName != undefined && this.commandFilterName != '') {
      aux = aux.filter((item: CommandinfoType) => {
        return item.nome.search(this.commandFilterName) > -1;
      });
    }
    if (this.commandFilterChannelSendSelect.length > 0) {
      aux = aux.filter((item: CommandinfoType) => {
        return this.commandFilterChannelSendSelect.includes(item.canalEnvioId);
      });
    }

    if (this.commandFilterNameSelect.length > 0) {
      aux = aux.filter((item: CommandinfoType) => {
        return this.commandFilterNameSelect.includes(item.nome);
      });
    }
    if (this.commandFilterDeviceModel.length > 0) {
      aux = aux.filter((item: CommandinfoType) => {
        if (item.dispositivoModelo != undefined) {
          return this.commandFilterDeviceModel.includes(item.dispositivoModelo);
        }
        return false;
      });
    }
    if (this.commandFilterSystemsSelect.length > 0) {
      aux = aux.filter((item: CommandinfoType) => {
        let auxBool = false;
        if (item.sistemaAux != undefined) {
          this.commandFilterSystemsSelect.forEach((itemSelect: string) => {
            if (item.sistemaAux != undefined) {
              item.sistemaAux.forEach((itemSistemaAux: string) => {
                if (itemSistemaAux == itemSelect) {
                  auxBool = true;
                }
              });
            }
          });
        }
        return auxBool;
      });
    }
    this.commandInfoFilter = aux;
  }

  filterCommandByName(
    item: CommandinfoType[],
    commandName: string
  ): CommandinfoType[] {
    return item.filter((itemFilter: CommandinfoType) => {
      return itemFilter.nome == commandName;
    });
  }

  openModal(centerDataModal: any) {
    this.modalService.open(centerDataModal, {
      size: 'lg',
      centered: true,
      windowClass: 'modal-holder',
    });
  }

  openModalSmall(centerDataModal: any) {
    this.modalService.open(centerDataModal, {
      size: 'sm',
      centered: true,
      windowClass: 'modal-holder',
    });
  }

  newModal(modal: any, item: CommandinfoType) {
    this.isAccessory = false;
    this.ngIfCopyModel = false;
    this.commandInfoSelect = [];
    this.commandInfoSelect.push(new CommandinfoType(item));
    if (this.commandInfoSelect[0].canalEnvioId == 0) {
      this.commandInfoSelect[0].canalEnvioId = 1;
    }
    this.openModal(modal);
  }
  updateModal(item: CommandinfoType, modal: any) {
    this.commandInfoSelect = [];
    this.commandInfoSelect.push(item);

    this.openModal(modal);
  }
  async insertItem(item: CommandinfoType) {
    this.circularProgressiveWait = true;
    item.sistemaNome = '';
    item.sistemaAux?.forEach((itemSistema: string) => {
      if (item.sistemaNome != '') {
        item.sistemaNome = item.sistemaNome + ',';
      }
      item.sistemaNome = item.sistemaNome + itemSistema;
    });
    delete item.sistemaAux;
    delete item.update_time;
    item.create_user = this.authService.currentUserValue.userId;
    this.commandsService.insertInfoCommand(item).subscribe(
      (response) => {
        this.ngOnInit();
        this.circularProgressiveWait = false;
        this.toastService.show('Item inserido com sucesso', {
          classname: 'bg-success text-center text-white',
          delay: 2000,
        });
      },
      (error: HttpErrorResponse) => {
        this.circularProgressiveWait = false;
        this.toastService.show('Erro ao alterar - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
      }
    );
  }
  async deleteItem(item: CommandinfoType) {
    this.circularProgressiveWait = true;
    item.sistemaNome = '';
    item.sistemaAux?.forEach((itemSistema: string) => {
      if (item.sistemaNome != '') {
        item.sistemaNome = item.sistemaNome + ',';
      }
      item.sistemaNome = item.sistemaNome + itemSistema;
    });
    item.update_user = this.authService.currentUserValue.userId;
    this.commandsService.updateInfoCommand(item).subscribe(
      (response) => {
        this.ngOnInit();
        this.circularProgressiveWait = false;
        this.toastService.show('Alterado com sucesso', {
          classname: 'bg-success text-center text-white',
          delay: 2000,
        });
      },
      (error: HttpErrorResponse) => {
        this.circularProgressiveWait = false;
        this.toastService.show('Erro ao alterar - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
      }
    );
  }

  async updateItem(item: CommandinfoType) {
    this.circularProgressiveWait = true;
    item.sistemaNome = '';
    item.sistemaAux?.forEach((itemSistema: string) => {
      if (item.sistemaNome != '') {
        item.sistemaNome = item.sistemaNome + ',';
      }
      item.sistemaNome = item.sistemaNome + itemSistema;
    });
    item.update_user = this.authService.currentUserValue.userId;
    this.commandsService.updateInfoCommand(item).subscribe(
      (response) => {
        this.ngOnInit();
        this.circularProgressiveWait = false;
        this.toastService.show('Alterado com sucesso', {
          classname: 'bg-success text-center text-white',
          delay: 2000,
        });
      },
      (error: HttpErrorResponse) => {
        this.circularProgressiveWait = false;
        this.toastService.show('Erro ao alterar - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
      }
    );
  }

  excludeItem(item: CommandinfoType) {
    this.commandsService.excludeInfoCommand(item).subscribe(
      () => {
        this.ngOnInit();
        this.toastService.show('Excluído com sucesso', {
          classname: 'bg-success text-center text-white',
          delay: 10000,
        });
      },
      (error: HttpErrorResponse) => {
        this.circularProgressiveWait = false;
        alert(error.message);
        this.toastService.show('Erro ao excluir - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
      }
    );
  }
}

interface SupplierItemHeader {
  supplier: string[];
  grouping: [
    {
      grouping: string;
      group: string[];
    }
  ];
  itemModel: string[];
}